import { useRef, useState } from "react";
import axios from "axios";

/**
 * Preus (el més barat per dia) carregats a poc a poc a mida que es navega
 * el calendari de qualsevol cercador, en comptes de calcular-ho tot (moltes
 * propietats x molts mesos) d'un cop a la càrrega de la pàgina.
 *
 * - `endpoint`: URL de l'AJAX (p.ex. '/preciosbuscadorgeneral').
 * - `extraParams`: paràmetres fixos que s'envien a cada petició, a més de
 *   mes/ano/meses (p.ex. { idPropiedad } o { idDestino }). Es recalcula la
 *   clau de cache si canvien, així un canvi de propietat/destino no reutilitza
 *   per error preus d'un altre àmbit.
 *
 * Retorna { preciosPorDia, cargandoPrecios, carregarPreusMes(date, meses) }.
 */
export default function usePreciosCalendario(endpoint, extraParams = {}) {

    const [preciosPorDia, setPreciosPorDia] = useState({});
    const [cargandoPrecios, setCargandoPrecios] = useState(false);
    const mesosCarregats = useRef(new Set());
    const peticionsEnVol = useRef(0);

    const carregarPreusMes = (date, meses = 2) => {
        if (!date) return;

        const ano = date.getFullYear();
        const mes = date.getMonth() + 1;
        const key = JSON.stringify({ ...extraParams, ano, mes });

        if (mesosCarregats.current.has(key)) return;
        mesosCarregats.current.add(key);

        const token = document.getElementById('meta_token')?.getAttribute('content');

        peticionsEnVol.current++;
        setCargandoPrecios(true);

        axios.post(endpoint, {
            mes,
            ano,
            meses,
            ...extraParams
        }, {
            headers: {
                'content-type': 'text/json',
                'X-CSRF-TOKEN': token
            }
        }).then((response) => {
            setPreciosPorDia((previ) => ({ ...previ, ...response.data }));
        }).catch(() => {
            // Permet reintentar-ho en la propera obertura/navegació.
            mesosCarregats.current.delete(key);
        }).finally(() => {
            peticionsEnVol.current = Math.max(0, peticionsEnVol.current - 1);
            if (peticionsEnVol.current === 0) setCargandoPrecios(false);
        });
    };

    return { preciosPorDia, cargandoPrecios, carregarPreusMes };
}
